import theme, { defaultTheme } from './themes';
import GlobalStyles from './globalstyles';

export default {
  ...theme,
};

export { GlobalStyles, defaultTheme };
